module.exports = __webpack_public_path__ + "img/question_bg.091d869b.png";